const NAMESPACE = "editIncentiveDesign";

const KEYS = {
    editIncentiveDesignHeader: "editIncentiveDesignHeader",
    viewIncentiveDesignHeader: "viewIncentiveDesignHeader",
    parentPageBreadcrumb: "parentPageBreadcrumb",
    incentiveNameLabel: "incentiveNameLabel",
    expirationBeforeActivationErrorText: "expirationBeforeActivationErrorText",
    effectiveDatesNote: "effectiveDatesNote",
    timeZoneNote: "timeZoneNote",
    useStartDateLabel: "useStartDateLabel",
    startDateAltLabel: "startDateAltLabel",
    useExpirationDateLabel: "useExpirationDateLabel",
    expirationDateAltLabel: "expirationDateAltLabel",
    conditionsCapsuleTitle: "conditionsCapsuleTitle",
    metadataCapsuleTitle: "metadataCapsuleTitle",
    incentiveTypeSelectLabel: "incentiveTypeSelectLabel",
    incentiveLengthLabel: "incentiveLengthLabel",
    incentiveValueInputConstantOption: "incentiveValueInputConstantOption",
    incentiveValueSelectFormulaOption: "incentiveValueSelectFormulaOption",
    incentiveValueFormulaSelectLabel: "incentiveValueFormulaSelectLabel",
    incentivePbiRateLabel: "incentivePbiRateLabel",
    incentiveTier1PbiRateLabel: "incentiveTier1PbiRateLabel",
    incentiveTier2PbiRateLabel: "incentiveTier2PbiRateLabel",
    incentiveEpbbRateLabel: "incentiveEpbbRateLabel",
    incentiveTier1EpbbRateLabel: "incentiveTier1EpbbRateLabel",
    incentiveTier2EpbbRateLabel: "incentiveTier2EpbbRateLabel",
    incentiveFlatAmountLabel: "incentiveFlatAmountLabel",
    perWattUnits: "perWattUnits",
    perkWhUnits: "perkWhUnits",
    kWUnits: "kWUnits",
    exposeFormulaLabel: "exposeFormulaLabel",
    incentiveAmountRoundingNote: "incentiveAmountRoundingNote",
    incentiveRateRoundingNote: "incentiveRateRoundingNote",
    ratingDataFieldLabel: "ratingDataFieldLabel",
    productionDataFieldLabel: "productionDataFieldLabel",
    incentiveValueDataFieldNote: "incentiveValueDataFieldNote",
    avgInvEfficiencyDataFieldLabel: "avgInvEfficiencyDataFieldLabel",
    annualDegradationLabel: "annualDegradationLabel",
    annualDegradationNote: "annualDegradationNote",
    maximumIncentivizedRatingOptionLabel: "maximumIncentivizedRatingOptionLabel",
    maximumIncentivizedRatingInputLabel: "maximumIncentivizedRatingInputLabel",
    useDesignFactorLabel: "useDesignFactorLabel",
    designFactorThresholdLabel: "designFactorThresholdLabel",
    designFactorThresholdNote: "designFactorThresholdNote",
    designFactorMaximumLabel: "designFactorMaximumLabel",
    designFactorMaximumNote: "designFactorMaximumNote",
    useProjectCostCapLabel: "useProjectCostCapLabel",
    projectCostDataFieldLabel: "projectCostDataFieldLabel",
    projectCostMaximumPctLabel: "projectCostMaximumPctLabel",
    projectCostDataFieldsNotAvailableNote: "projectCostDataFieldsNotAvailableNote",
    useAnnualUsageCapLabel: "useAnnualUsageCapLabel",
    annualUsageDataFieldLabel: "annualUsageDataFieldLabel",
    annualUsageDataFieldsNotAvailableNote: "annualUsageDataFieldsNotAvailableNote",
    maximumAmountCapOptionLabel: "maximumAmountCapOptionLabel",
    maximumAmountCapInputLabel: "maximumAmountCapInputLabel",
    approvedAmountCapLabel: "approvedAmountCapLabel",
    tier1RatingCutoffLabel: "tier1RatingCutoffLabel",
    tier2RatingCutoffLabel: "tier2RatingCutoffLabel",
    tier1RatingCutoffDataFieldSelectLabel: "tier1RatingCutoffDataFieldSelectLabel",
    tier1RatingCutoffNote: "tier1RatingCutoffNote",
    tier2IncentiveRateLabel: "tier2IncentiveRateLabel",
    tier2IncentiveRateNote: "tier2IncentiveRateNote",
    tier2RatingCutoffNote: "tier2RatingCutoffNote",
    tierRatingCutoffErrorText: "tierRatingCutoffErrorText",
    genericNoSelectionOption: "genericNoSelectionOption",
    noAvailableSelectionOption: "noAvailableSelectionOption",
    dataFieldNoSelectionOption: "dataFieldNoSelectionOption",
    cancelButtonText: "cancelButtonText",
    closeButtonText: "closeButtonText",
    saveButtonText: "saveButtonText"
};

const MESSAGES = {
    [KEYS.editIncentiveDesignHeader]: {
        value: "Edit Incentive Design",
        comment: "Header for the Edit Incentive Design page"
    },
    [KEYS.viewIncentiveDesignHeader]: {
        value: "View Incentive Design",
        comment: "Header for the View Incentive Design page"
    },
    [KEYS.parentPageBreadcrumb]: {
        value: "Incentive Designs",
        comment: "Breadcrumb text for the parent Incentive Design List page"
    },
    [KEYS.incentiveNameLabel]: {
        value: "Incentive Name",
        comment: "Label for the Incentive Name input"
    },
    [KEYS.expirationBeforeActivationErrorText]: {
        value: "The Expiration date must be later than the Activation date.",
        comment: "Error message displayed when the Expiration date is not after the Activation date"
    },
    [KEYS.effectiveDatesNote]: {
        value: "If defined, Activation and Expiration occur the moment these dates are reached.",
        comment: "Note displayed to explain when Activation and Expiration occur"
    },
    [KEYS.timeZoneNote]: {
        value: "Dates will be interpreted in your program's time zone:",
        comment: "Note displayed to explain that Dates are in the program time zone"
    },
    [KEYS.useStartDateLabel]: {
        value: "Define Activation Date",
        comment: "Label for the checkbox used to toggle use of the Activation Date input"
    },
    [KEYS.startDateAltLabel]: {
        value: "Activation Date Input",
        comment: "Alt-label for the Activation Date input"
    },
    [KEYS.useExpirationDateLabel]: {
        value: "Define Expiration Date",
        comment: "Label for the checkbox used to toggle use of the Expiration Date input"
    },
    [KEYS.expirationDateAltLabel]: {
        value: "Expiration Date Input",
        comment: "Alt-label for the Expiration Date input"
    },
    [KEYS.conditionsCapsuleTitle]: {
        value: "Eligibility Conditions",
        comment: "Title of the Eligibility Conditions capsule"
    },
    [KEYS.metadataCapsuleTitle]: {
        value: "Metadata",
        comment: "Title of the Incentive Metadata capsule"
    },
    [KEYS.incentiveTypeSelectLabel]: {
        value: "Incentive Type",
        comment: "Label for the Incentive Type input"
    },
    [KEYS.incentiveLengthLabel]: {
        value: "Incentive Length (years)",
        comment: "Label for the Incentive Length input"
    },
    [KEYS.incentiveValueInputConstantOption]: {
        value: "Input a Constant Value",
        comment: "Label for the Constant Value input option"
    },
    [KEYS.incentiveValueSelectFormulaOption]: {
        value: "Select a Formula",
        comment: "Label for the Formula selection option"
    },
    [KEYS.incentiveValueFormulaSelectLabel]: {
        value: "Select Formula:",
        comment: "Label for the Formula drop-down list"
    },
    [KEYS.incentivePbiRateLabel]: {
        value: "Incentive Rate ({'$'}/kWh)",
        comment: "Label for the PBI Incentive Rate input"
    },
    [KEYS.incentiveTier1PbiRateLabel]: {
        value: "Tier 1 Incentive Rate ({'$'}/kWh)",
        comment: "Label for the Tier 1 PBI Incentive Rate input"
    },
    [KEYS.incentiveTier2PbiRateLabel]: {
        value: "Tier 2 Incentive Rate ({'$'}/kWh)",
        comment: "Label for the Tier 2 PBI Incentive Rate input"
    },
    [KEYS.incentiveEpbbRateLabel]: {
        value: "Incentive Rate ({'$'}/W)",
        comment: "Label for the EPBB Incentive Rate input"
    },
    [KEYS.incentiveTier1EpbbRateLabel]: {
        value: "Tier 1 Incentive Rate ({'$'}/W)",
        comment: "Label for the Tier 1 EPBB Incentive Rate input"
    },
    [KEYS.incentiveTier2EpbbRateLabel]: {
        value: "Tier 2 Incentive Rate ({'$'}/W)",
        comment: "Label for the Tier 2 EPBB Incentive Rate input"
    },
    [KEYS.incentiveFlatAmountLabel]: {
        value: "Incentive Amount ({'$'})",
        comment: "Label for the Flat Incentive Amount input"
    },
    [KEYS.perWattUnits]: {
        value: " / W",
        comment: "Label for the per-watt unit"
    },
    [KEYS.kWUnits]: {
        value: " kW",
        comment: "Label for the kilowatt unit"
    },
    [KEYS.perkWhUnits]: {
        value: " / kWh",
        comment: "Label for the per-kilowatt-hour unit"
    },
    [KEYS.exposeFormulaLabel]: {
        value: "In the Incentive Selector element, display the Calculation Details for this Formula to non-Admins",
        comment:
            "Label for the checkbox used to toggle whether Calculation Details will be displayed for a Flat Amount formula"
    },
    [KEYS.incentiveAmountRoundingNote]: {
        value: "The incentive amount will be rounded to 2 decimal places.",
        comment: "Label indicating the decimal places used for the Incentive Amount"
    },
    [KEYS.incentiveRateRoundingNote]: {
        value: "The incentive rate will be rounded to 4 decimal places.",
        comment: "Label indicating the decimal places used for the Incentive Rate"
    },
    [KEYS.ratingDataFieldLabel]: {
        value: "Rating Data Field",
        comment: "Label for the Rating data field selector"
    },
    [KEYS.productionDataFieldLabel]: {
        value: "Estimated Production Data Field",
        comment: "Label for the Estimated Production data field selector"
    },
    [KEYS.incentiveValueDataFieldNote]: {
        value: "This is the data field which is used to calculate the incentive amount itself.",
        comment: "Label used to explain the purpose of the Incentive Value data field"
    },
    [KEYS.avgInvEfficiencyDataFieldLabel]: {
        value: "Average Inverter Efficiency Data Field",
        comment: "Label for the Average Inverter Efficiency data field selectro"
    },
    [KEYS.annualDegradationLabel]: {
        value: "Annual System Degradation (%)",
        comment: "Label for the Annual System Degradation input"
    },
    [KEYS.annualDegradationNote]: {
        value:
            "This is the percentage by which the system production calculation should be reduced from year to year." +
            " An input of 0.0% means there will be no reduction; an input of 0.5% means that each year's production" +
            " will be 99.5% of the previous year's.  This input will be rounded to 2 decimal places.",
        comment: "Text used to explain the Annual Degradation value"
    },
    [KEYS.maximumIncentivizedRatingOptionLabel]: {
        value: "Define Maximum Incentivized Rating",
        comment: "Label for the checkbox used to toggle use of the Maximum Incentivized Rating input"
    },
    [KEYS.maximumIncentivizedRatingInputLabel]: {
        value: "Define Maximum Incentivized Rating (kW)",
        comment: "Label for the Maximum Incentive Rating input"
    },
    [KEYS.useDesignFactorLabel]: {
        value: "Multiply Rating by System Design Factor",
        comment: "Label for the checkbox used to toggle use of the Design Factor in the incentive calculation"
    },
    [KEYS.designFactorThresholdLabel]: {
        value: "Design Factor Threshold (%, optional)",
        comment: "Label for the Design Factor Threshold input"
    },
    [KEYS.designFactorThresholdNote]: {
        value: "If the system Design Factor is this value or more, 1.00 (100%) will be used as the Design Factor in the incentive calculation.",
        comment: "Text used to explain the Design Factor Threshold value"
    },
    [KEYS.designFactorMaximumLabel]: {
        value: "Design Factor Maximum (%, optional)",
        comment: "Label for the Design Factor Maximum input"
    },
    [KEYS.designFactorMaximumNote]: {
        value: "If the system Design Factor is more than this value, this value will be used as the Design Factor in the incentive calculation.",
        comment: "Text used to explain the Design Factor Maximum value"
    },
    [KEYS.useProjectCostCapLabel]: {
        value: "Define Maximum Incentive Amount By Percentage of Project Cost",
        comment: "Label for the checkbox used to toggle the use of the Project Cost cap"
    },
    [KEYS.projectCostDataFieldLabel]: {
        value: "Project Cost Data Field",
        comment: "Label for the Project Cost data field selector"
    },
    [KEYS.projectCostMaximumPctLabel]: {
        value: "Maximum % of Cost",
        comment: "Label for the Project Cost cap percentage input"
    },
    [KEYS.projectCostDataFieldsNotAvailableNote]: {
        value: "This option is not available because there are no Cost Data Fields defined.",
        comment: "Text displayed when there are no data fields available for the Project Cost cap"
    },
    [KEYS.useAnnualUsageCapLabel]: {
        value: "Limit Incentive Amount Based on Customer's Annual Usage",
        comment: "Label for the checkbox used to toggle the use of the Annual Usage cap"
    },
    [KEYS.annualUsageDataFieldLabel]: {
        value: "Annual Usage Data Field",
        comment: "Label for the Annual Usage data field selector"
    },
    [KEYS.annualUsageDataFieldsNotAvailableNote]: {
        value: "This option is not available because there are no Annual Usage Data Fields defined.",
        comment: "Text displayed when there are no data fields available for the Annual Usage cap"
    },
    [KEYS.maximumAmountCapOptionLabel]: {
        value: "Define Fixed Maximum Incentive Amount",
        comment: "Label for the checkbox used to toggle the use of the Maximum Amount cap"
    },
    [KEYS.maximumAmountCapInputLabel]: {
        value: "Define Fixed Maximum Incentive Amount ({'$'})",
        comment: "Label for the Maximum Incentive Amount input"
    },
    [KEYS.approvedAmountCapLabel]: {
        value: "Limit Incentive Amount to Approved Amount",
        comment: "Label for the checkbox used to toggle the use of the Approved Amount cap"
    },
    [KEYS.tier1RatingCutoffLabel]: {
        value: "Maximum System Rating for Tier 1 (kW)",
        comment: "Label for the Tier 1 Rating Cutoff input"
    },
    [KEYS.tier2RatingCutoffLabel]: {
        value: "Maximum System Rating for Tier 2 (kW)",
        comment: "Label for the Tier 2 Rating Cutoff input"
    },
    [KEYS.tier1RatingCutoffDataFieldSelectLabel]: {
        value: "Rating Data Field to Use for Cutoff",
        comment: "Label for the Tier 1 Rating Cutoff data field selector"
    },
    [KEYS.tier1RatingCutoffNote]: {
        value:
            "The Tier 1 incentive rate will be used for the amount of the indicated System Rating" +
            " up to and including the value input above.",
        comment: "Text explaining the Tier 1 Rating Cutoff value"
    },
    [KEYS.tier2IncentiveRateLabel]: {
        value: "Tier 2 Incentive Rate ({'$'}/W)",
        comment: "Label for the Tier 2 EPBB Incentive Rate input"
    },
    [KEYS.tier2IncentiveRateNote]: {
        value:
            "The Tier 2 rate is used for the amount of the system size above the cutoff input above." +
            " This rate will be rounded to 4 decimal places.",
        comment: "Text explaining the Tier 2 Incentive Rate value"
    },
    [KEYS.tier2RatingCutoffNote]: {
        value: "The Tier 2 cutoff uses the same Rating Data Field as Tier 1.",
        comment: "Text explaining the Tier 2 Rating Cutoff uses the Tier 1 Rating Cutoff data field"
    },
    [KEYS.tierRatingCutoffErrorText]: {
        value: "The Tier 2 cutoff rating must be greater than that for Tier 1.",
        comment: "Error message if the Tier 2 cutoff rating value is not greater than the Tier 1 cutoff rating value"
    },
    [KEYS.genericNoSelectionOption]: {
        value: "Select...",
        comment: "Default option when there has been no selection made in a dropdown list"
    },
    [KEYS.noAvailableSelectionOption]: {
        value: "There is no option available",
        comment: "Placeholder option displayed when there are no options available in a dropdown list"
    },
    [KEYS.dataFieldNoSelectionOption]: {
        value: "Select a data field...",
        comment: "Default option when there has been no selection made in a dropdown list of data fields"
    },
    [KEYS.cancelButtonText]: {
        value: "Cancel",
        comment: "Button text for Cancel button"
    },
    [KEYS.closeButtonText]: {
        value: "Close",
        comment: "Button text for Close button"
    },
    [KEYS.saveButtonText]: {
        value: "Save",
        comment: "Button text for Save button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
